import { render } from "./Checkbox.vue?vue&type=template&id=cc10cdf0&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"

import "./Checkbox.vue?vue&type=style&index=0&id=cc10cdf0&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-property-b2b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc10cdf0"],['__file',"src/assets/js/components/Form/Checkbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cc10cdf0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cc10cdf0', __exports__)) {
    api.reload('cc10cdf0', __exports__)
  }
  
  module.hot.accept("./Checkbox.vue?vue&type=template&id=cc10cdf0&scoped=true", () => {
    api.rerender('cc10cdf0', render)
  })

}


export default __exports__